import { render, staticRenderFns } from "./Poi.vue?vue&type=template&id=6ec3c8c5&"
import script from "./Poi.vue?vue&type=script&lang=js&"
export * from "./Poi.vue?vue&type=script&lang=js&"
import style0 from "./Poi.vue?vue&type=style&index=0&id=6ec3c8c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports